export default __webpack_public_path__ + "img/tremors/tremors5_480.webp";